module.exports = __webpack_public_path__ + "img/meyburz.0817482f.jpg";